module.exports = __webpack_public_path__ + "img/Guyana.2efb790b.gif";